import { motion } from "framer-motion";

export default function FinalCTA() {
  return (
    <section className="relative py-28 md:py-40 overflow-hidden bg-zoku-bg" data-testid="final-cta-section">
      <div className="absolute inset-0">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-zoku-orangeLight blur-3xl opacity-80" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative max-w-4xl mx-auto text-center px-6"
      >
        <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.02] text-zoku-ink">
          Your body <span className="font-editorial text-zoku-orange">talks.</span>
          <br />
          Now you can listen.
        </h2>
        <p className="mt-8 text-lg md:text-xl text-zoku-ink2 max-w-2xl mx-auto">
          Join 850,000 people who finally understand their sleep, strain and everything they eat.
          Free to download. No subscription to get started.
        </p>

        <div className="mt-12 flex flex-wrap justify-center gap-3">
          <a
            href="https://apps.apple.com/in/app/zoku-track-calories/id6762446883"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-1.5 bg-zoku-ink text-white rounded-full pl-5 pr-7 py-4 hover:bg-stone-800 transition-all active:scale-95 shadow-lg"
            data-testid="final-appstore-btn"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_zoku-wellness-hub/artifacts/8gdpr0ux_apple-icon-4.png"
              alt=""
              className="w-7 h-7 object-contain"
              style={{ filter: "invert(1) brightness(2)" }}
            />
            <span className="text-left leading-tight">
              <span className="block text-[10px] uppercase tracking-wider opacity-70">
                Download on the
              </span>
              <span className="block text-lg font-semibold">App Store</span>
            </span>
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-sm text-zoku-ink3">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-500" /> 4.8★ App Store
          </div>
          <div className="h-4 w-px bg-stone-300" />
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-500" /> Free forever tier
          </div>
        </div>
      </motion.div>
    </section>
  );
}
